import {
  LOADING_ARRAY,
  LIST_COMMUNITY_ALERTS_REQUEST,
  LIST_COMMUNITY_ALERTS_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// communityId -> [alerts]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_COMMUNITY_ALERTS_REQUEST:
      return {
        ...state,
        [action.communityId]: state[action.communityId] || LOADING_ARRAY,
      }

    case LIST_COMMUNITY_ALERTS_RESPONSE: {
      return {
        ...state,
        [action.communityId]: (action.alerts || []).map((a) => a.id),
      }
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
